import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCurrentAccessWeekdays } from 'modules/core/hooks/useCurrentAccessWeekdays'
import i18n from 'modules/core/lib/i18n'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'
import { asShortDay } from 'modules/contracts/lib/shortDays'

import WorkableDay from './WorkableDay'

interface Props {
  workableDays: string
}

const WorkableDays = ({ workableDays }: Props) => {
  const weekDays = useCurrentAccessWeekdays()
  const selectedDays = workableDays ? workableDays.split(',') : []

  const isActive = (target: string) => {
    return !!selectedDays.find((day) => day === target)
  }

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 3 }} gap="s8">
      <Box flexDirection="row" gap="s4" alignItems="center">
        <Text size="200" weight="normal" color="grey800">
          {i18n.t('contract_versions.time.workable_days.title')}
        </Text>
        <ContractTooltip
          information={i18n.t('contract_versions.time.workable_days.tooltip')}
          icon="info-circle-line"
        />
      </Box>
      <Box gap="s2" flexDirection="row">
        {weekDays.map((day) => {
          const shortDay = asShortDay(day)

          return <WorkableDay key={`day-${day}`} title={shortDay ?? ''} active={isActive(day)} />
        })}
      </Box>
    </Box>
  )
}

export default observer(WorkableDays)
